import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const VendorAssignmentSelect = ({ selectedVendors, onChange, vendorList }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const handleToggleVendor = (vendor) => {
    if (vendor === 'ALL VENDORS') {
      onChange(selectedVendors.includes('ALL VENDORS') ? [] : ['ALL VENDORS']);
      return;
    }

    if (selectedVendors.includes('ALL VENDORS')) {
      // If 'ALL VENDORS' is selected, clear it and add the new vendor
      onChange([vendor]);
    } else if (selectedVendors.includes(vendor)) {
      // Remove vendor
      onChange(selectedVendors.filter(v => v !== vendor));
    } else {
      // Add vendor
      onChange([...selectedVendors, vendor]);
    }
  };

  const displayValue = selectedVendors.length === 0 
    ? 'اختر البائعين...' 
    : selectedVendors.includes('ALL VENDORS') 
      ? 'جميع البائعين'
      : selectedVendors.join(', ');

  return (
    <div className="relative">
      <button
        type="button"
        className="w-full p-3 border border-indigo-300 rounded-lg bg-white text-left flex justify-between items-center focus:ring-indigo-500 focus:border-indigo-500 transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        {displayValue}
        <ChevronDown className={`w-4 h-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
      </button>
      {isOpen && (
        <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {vendorList.map(vendor => (
            <div
              key={vendor}
              className="p-3 hover:bg-indigo-50 cursor-pointer flex items-center"
              onClick={() => handleToggleVendor(vendor)}
            >
              <input
                type="checkbox"
                checked={selectedVendors.includes(vendor)}
                readOnly
                className="mr-2 text-indigo-600 rounded"
              />
              {vendor}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorAssignmentSelect;
